import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import SidebarContentEnvAudit from "./SidebarContentEnvAudit"

/*
  March 13, 2025.

  The Division of Environmental Compliance and Enforcement (DECE) is made up of 
  Environmental Audit Service, Plastics Authorization, Disposal Guidance, 
  Import Chemical License, Export Chemical License, Other Convention License

  REMA wants us to have a separate dashboard for DECE.
  This Dashboard will list out all services within the division.
  
  What this means is that once a staff logs in, there'll be a blank navigation
  menu. A custom Dashboard showing all services will be the first page rendered.
  Clicking on a service will render the navigation for that service.

  I want to implement a Redux store in a way that if somewhere in the react app,
  show_env_audit_navigation is set to true, then the sidebar the is shown below will
  be SidebarContentEnvAudit else the sidebar should be SidebarContent.

*/

import { showEnvAuditNavigation } from "../../store/actions"

const Sidebar = props => {
  const [showBlankNavigation, setshowBlankNavigation] = useState(false)
  useEffect(()=>{
    // console.log("show env nav", props.showEnvAuditNav)

    const user = JSON.parse(localStorage.getItem("authUser"))
    // When a user first logs in, we'll show a blank navigation if department is env
    // compliance
    // if (user.department_id == 1) {
    //   setshowBlankNavigation(true)
    // }

    // console.log("user ", user)
  }, [])
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {/* {props.type !== "condensed" ? <SidebarContentEnvAudit /> : <SidebarContentEnvAudit />} */}
          {props.showEnvAuditNav == "SHOW_ENV_AUDIT_NAVIGATION" ? <SidebarContentEnvAudit /> : <SidebarContent showBlankNavigation={showBlankNavigation} />}
          {/* <SidebarContent /> */}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
  showEnvAuditNavigation: PropTypes.func
}

// const mapStateToProps = state => {
//   return {
//     layout: state.Layout,
//   }
// }

const mapStateToProps = (state) => ({
  showEnvAuditNav: state.Layout.show_env_audit_navigation, 
});

export default connect(
  mapStateToProps,
  {showEnvAuditNavigation}
)(withRouter(withTranslation()(Sidebar)))
